module.exports = __webpack_public_path__ + "img/iletiyonetimsistemi.36c67e1a.png";